<template>
    <ImportPreviewTable
        :preview-data="previewData"
        :title="title"
        :show-summary="showSummary"
        :summary-cards="consentSummaryCards"
        :custom-columns="consentCustomColumns"
        :table-headers="consentTableHeaders"
        :items-per-page="itemsPerPage"
        :hide-footer="hideFooter"
        :loading="loading"
        :auto-filter-to-errors="autoFilterToErrors"
    >
        <!-- Consent-specific column slots -->
        <template #column-conversational="{ value }">
            <v-chip :color="getConsentColor(value)" text-color="white" small>
                {{ formatConsentValue(value) }}
            </v-chip>
        </template>

        <template #column-informational="{ value }">
            <v-chip :color="getConsentColor(value)" text-color="white" small>
                {{ formatConsentValue(value) }}
            </v-chip>
        </template>

        <template #column-promotional="{ value }">
            <v-chip :color="getConsentColor(value)" text-color="white" small>
                {{ formatConsentValue(value) }}
            </v-chip>
        </template>

        <template #column-rc_specimen="{ value }">
            <v-chip :color="(value && value.trim()) ? 'success' : 'grey'" text-color="white" small>
                <v-icon small>
                    {{ (value && value.trim()) ? 'mdi-check' : 'mdi-close' }}
                </v-icon>
            </v-chip>
        </template>
    </ImportPreviewTable>
</template>

<script>
import ImportPreviewTable from '@/components/common/import-preview-table.vue';

export default {
    name: 'consent-import-preview-table',

    components: {
        ImportPreviewTable
    },

    props: {
        previewData: {
            type: Object,
            default: null
        },
        title: {
            type: String,
            default: ''
        },
        showSummary: {
            type: Boolean,
            default: true
        },
        itemsPerPage: {
            type: Number,
            default: 25
        },
        hideFooter: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        autoFilterToErrors: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        consentSummaryCards() {
            return [
                { key: 'total_records', label: 'Total Rows', cols: 3 },
                { key: 'conversational_count', label: 'Conversational Consent Records', cols: 3 },
                { key: 'informational_count', label: 'Informational Consent Records', cols: 3 },
                { key: 'promotional_count', label: 'Promotional Consent Records', cols: 3 }
            ];
        },

        consentCustomColumns() {
            return [
                { key: 'conversational', type: 'consent' },
                { key: 'informational', type: 'consent' },
                { key: 'promotional', type: 'consent' },
                { key: 'rc_specimen', type: 'specimen' }
            ];
        },

        consentTableHeaders() {
            return [
                { text: 'Row', value: 'row_number', width: '60px', align: 'center' },
                { text: 'Status', value: 'import_status', width: '100px', align: 'center' },
                { text: 'Full Name', value: 'full_name' },
                { text: 'Phone Number', value: 'rc_phone_number' },
                { text: 'Consent Date', value: 'rc_consent_date' },
                { text: 'Conversational', value: 'conversational', align: 'center' },
                { text: 'Informational', value: 'informational', align: 'center' },
                { text: 'Promotional', value: 'promotional', align: 'center' },
                { text: 'Has Specimen?', value: 'rc_specimen', width: '100px', align: 'center' },
                { text: 'Errors', value: 'errors' }
            ];
        }
    },

    methods: {
        getConsentColor(value) {
            if (!value || value.trim() === '') return 'grey';

            const normalizedValue = value.toLowerCase().trim();
            // Simplified logic - backend should be sending standardized values
            if (['grant', 'granted', 'yes', 'y', 'true', '1'].includes(normalizedValue)) {
                return 'success';
            } else if (['deny', 'denied', 'no', 'n', 'false', '0'].includes(normalizedValue)) {
                return 'red';
            } else if (['revoke', 'revoked'].includes(normalizedValue)) {
                return 'orange';
            }
            return 'grey';
        },

        formatConsentValue(value) {
            if (!value || value.trim() === '') return '-';

            const normalizedValue = value.toLowerCase().trim();
            // Simplified logic - backend should be sending standardized values
            if (['grant', 'granted', 'yes', 'y', 'true', '1'].includes(normalizedValue)) {
                return 'Grant';
            } else if (['deny', 'denied', 'no', 'n', 'false', '0'].includes(normalizedValue)) {
                return 'Deny';
            } else if (['revoke', 'revoked'].includes(normalizedValue)) {
                return 'Revoke';
            }
            return value; // Show original value if not recognized
        }
    }
};
</script>
